import {BrowserRouter} from "react-router-dom";
import {AppRoutes} from "./routes/AppRoutes";
import {ThemeProvider} from "@mui/material";
import {useEffect} from "react";
import {AppDispatch} from "@core/store";
import {useDispatch, useSelector} from "react-redux";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import "dayjs/locale/es";
import dayjs from "dayjs";
import {initI18n} from "@core/store/slices/i18nSlice";
import i18n from "./i18n";
import {useThemeContext} from "@theme";
import {useTokenRefresher} from "@hooks";
import {Snackbar} from "@components";
import {enUS, esES, itIT} from "@mui/x-date-pickers/locales";
import {translate} from "@util";
import {Selectors} from "@core/store/selectors";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";

const getMuiLocaleText = (locale: string) => {
  switch (locale) {
    case "it":
      return itIT.components.MuiLocalizationProvider.defaultProps.localeText;
    case "en":
      return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    case "es":
      return esES.components.MuiLocalizationProvider.defaultProps.localeText;
    default:
      return itIT.components.MuiLocalizationProvider.defaultProps.localeText;
  }
};

const App = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {theme} = useThemeContext();

  const locale = useSelector(Selectors.locale);
  const localeText = getMuiLocaleText(locale);

  useEffect(() => {
    dispatch(initI18n(i18n));
  }, [dispatch, i18n]);

  useEffect(() => {
    dayjs.locale(locale);
    //dayjs.extend(require("dayjs/plugin/localizedFormat"));
  }, [locale]);

  useTokenRefresher();

  return (
    <DndProvider backend={HTML5Backend}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          key={`localization-provider-${locale}`}
          dateAdapter={AdapterDayjs}
          adapterLocale={locale}
          localeText={{
            ...localeText,
            clearButtonLabel: translate("common.action.reset"),
          }}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>

          <Snackbar />
        </LocalizationProvider>
      </ThemeProvider>
    </DndProvider>
  );
};

export {App};
